import ReactDOM from "react-dom";
import { useState, useEffect, useRef } from "react";

const DropdownTest = ({ isOpen, buttonRef, children }) => {
  if (!isOpen || !buttonRef) return null;

  const buttonRect = buttonRef.getBoundingClientRect();

  return ReactDOM.createPortal(
    <div
      className="absolute z-50  rounded-lg shadow-lg"
      style={{
        top: buttonRect.bottom + window.scrollY, // Adjust for scroll
        left: buttonRect.left + window.scrollX, // Adjust for scroll
        minWidth: buttonRect.width, // Match button width
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export default DropdownTest;
